export default "__VITE_ASSET__bf7268ed__"